export const dataBindingBundlesConfig = {
    parts: false,
    components: true,
    host: true,
};
export const dataBindingConventions = {
    getComponentName: ({ componentName }) => `$w.${componentName}`,
    patterns: [
        {
            part: 'dataBindingPanel',
            path: '{,*/}editor/panels/dataBinding/%ComponentName%.dataBindingPanel.ts',
        },
    ],
};
//# sourceMappingURL=dataBinding.js.map